import { render, staticRenderFns } from "./app-view-formatter.vue?vue&type=template&id=80f2a1cc&"
import script from "./app-view-formatter.vue?vue&type=script&lang=js&"
export * from "./app-view-formatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports